import React from "react";
import { Link } from "../../../packages/router/Link.js";
import { LogoutLink } from "./LogoutLink.js";
import { MenuSection } from "./MenuSection.js";
import { MenuItem } from "./MenuItem.js";

/**
 * Renders the application menu.
 */
export const Menu = () => {
  return (
    <>
      <MenuSection title="Raamatupidamine">
        <MenuItem>
          <Link to="/entries">Kirjed</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/templates">Vormid</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/accounts">Kontod</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/vat">KM</Link>
        </MenuItem>
        <MenuItem>
          <a href="/eeskirjad.pdf?d=2026-10-08" target="_blank">
            Eeskirjad
          </a>
        </MenuItem>
      </MenuSection>
      <MenuSection title="Blogi">
        <MenuItem>
          <Link to="/comments">Kommentaarid</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/analytics">Analüütika</Link>
        </MenuItem>
      </MenuSection>
      <MenuSection title="Muu">
        <MenuItem>
          <Link to="/cloud">Pilv</Link>
        </MenuItem>
        <MenuItem>
          <Link to="/ambright">Ambright</Link>
        </MenuItem>
        <MenuItem>
          <a href="/log" target="_blank">
            Logipuhver
          </a>
        </MenuItem>
        <MenuItem>
          <LogoutLink />
        </MenuItem>
      </MenuSection>
    </>
  );
};
